export function buildGroupedOptions(config) {
  if (!config) return [];

  return Object.entries(config).map(([sectionKey, section]) => {
    const fields = section.FIELDS || {};

    const options = Object.entries(fields).flatMap(([fieldKey, fieldDef]) => {
      // Case 1: array fields (like JURISDICTIONAL_ASSIGNMENT, SOCIAL_MEDIA)
      if (Array.isArray(fieldDef)) {
        return fieldDef.flatMap((nested) =>
          Object.entries(nested)
            .filter(([k]) => k !== "PREVIEW")
            .map(([nestedKey, nestedDef]) => ({
              value: nestedKey,
              label: nestedDef.MESSAGE || nestedKey,
              type: nestedDef.TYPE,
              section: sectionKey,
            }))
        );
      }

      // Case 2: single object
      if (typeof fieldDef === "object" && fieldDef !== null) {
        return [
          {
            value: fieldKey,
            label: fieldDef.MESSAGE || fieldKey,
            type: fieldDef.TYPE,
            section: sectionKey,
          },
        ];
      }

      return [];
    });

    return {
      label: section.MESSAGE || sectionKey,
      options,
    };
  });
}
